module.exports = __webpack_public_path__ + "static/media/cardBg3.a0087cf5.png";